'use strict';

module.exports = function setRequestTimoutId (
  request,
  requestArgs,
  timeoutId,
  meta = {}
) {
  return {
    payload: {
      timeoutId,
    },
    type: 'DATA_CONNECTOR_SET_REQUEST_TIMEOUT_ID',
    isStoreSetAction: true,
    meta: {
      reference: request.referenceFor(...requestArgs),
      ...meta,
    },
  };
};



// WEBPACK FOOTER //
// ./lib/rlink-data-connector/setRequestTimeoutId.js